export class ProjectsActions {
  static readonly SET_PROJECTS = '[PROJECTS] SET';
};
